<template>
  <el-container>
    <el-header height="60px">
      <el-row>
        <!--        <el-col :span="8"><div class="header-grid-content">1</div></el-col>-->
        <el-col :xs="18" :sm="8" :md="8" :lg="8" :xl="8">
          <div class="logo_img">
            <el-image :src="logo" style="width: 45px;
                   height: 34px;"></el-image>
          </div>
          <div class="titile_logo"><a href="/">MxDraw云图帮助</a></div>
        </el-col>
        <el-col
          :xs="6"
          :sm="16"
          :md="16"
          :lg="16"
          :xl="16"
          style="float: right;"
         
        >
          <span class="hearder-tips logout" style="width: 50px" @click="logout">退出></span>
          <div  class="hidden-sm-and-down">
            <template  v-if="userInfo.usertype=='email'">
              <span class="hearder-tips" @click="drawer = true" >
                <i class="el-icon-user-solid"></i>
                {{userInfo.nickName}}
              </span>
            </template>
            <template v-else>
              <span class="hearder-tips">
                <i class="el-icon-user-solid"></i>
                {{userInfo.nickName}}
              </span>
            </template>
          <router-link to="mywork">
            <span class="hearder-tips">工单</span>
          </router-link>
          <router-link to="MxChm">
            <span class="hearder-tips">开发文档</span>
          </router-link>
          </div>
          
        </el-col>
        <el-drawer
          title="我是标题"
          :visible.sync="drawer"
          :with-header="false"
          size="15%"
          >
          <span>用户名：{{userInfo.nickName}}</span><br>
          <span>购买产品：{{userInfo.goods}}</span><br>
          <span>购买时间：{{userInfo.startTime}}</span><br>
          <span>到期时间：{{userInfo.endTime}}</span>
        </el-drawer>
      </el-row>
    </el-header>
    <el-container>
      <el-aside width="200px" class="hidden-sm-and-down">
        <el-row class="tac">
          <el-col :span="24">
            <el-menu
              router
              default-active="3"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
            >
              <a href="/mywork"><el-menu-item>
                <i class="el-icon-location"></i>
                <span slot="title">我的工单</span>
              </el-menu-item></a>
              <el-menu-item index="/workorder">
                <i class="el-icon-menu"></i>
                <span slot="title">创建工单</span>
              </el-menu-item>
              <template v-if="userInfo.usertype=='email'">
                <a href="/downloadList"><el-menu-item index="3" class="is-active">
                  <i class="el-icon-document"></i>
                  <span slot="title">控件下载</span>
                </el-menu-item></a>
              </template>

              
              <!-- <el-menu-item index="4" disabled>
                <i class="el-icon-setting"></i>
                <span slot="title">VIP技术支持</span>
              </el-menu-item>-->
            </el-menu>
          </el-col>
        </el-row>
      </el-aside>
      <el-container>
        <el-header class="hearder-2">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item><a href="/mywork">下载列表</a></el-breadcrumb-item>
          </el-breadcrumb>
        </el-header>
        <el-main>
          <el-card shadow="always">
            <!-- <div style="margin-top: 15px;">
              <el-input placeholder="请输入搜索关键词" v-model="keywords" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
              </el-input>
            </div> -->
            <el-table border :data="tableData" style="width: 100%">
              <el-table-column prop="name" label="文件名称"></el-table-column>
              <el-table-column prop="size" label="文件大小"></el-table-column>
              <el-table-column prop="type" label="目录名称"></el-table-column>
    
              <el-table-column label="操作">
                <template slot-scope="scope">
                   <el-button  size="mini" @click="download(scope.row.uuid)">下载</el-button>

                  <!-- <el-button size="mini" type="danger" @click="deleteWork(scope.row.uuid)">删除</el-button> -->
                </template>
              </el-table-column>
            </el-table>
            <template v-if="count>15">
              <el-pagination
                :current-page="pageIndex"
                @current-change="getPageIndex"
                background
                layout="prev, pager, next"
                :page-size="pagesize"
                :total="count"
              ></el-pagination>
            </template>
          </el-card>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: "work_order",
  data() {
    return {
      logo: require("../assets/img/logo2.png"),
      userInfo: {},
      keywords: "",
      count: null,
      total: null,
      tableData: [],
      pageIndex: 0,
      pagesize: null,
      drawer: false,
    };
  },
  mounted: function () {
    this.get();
  },
  methods: {
    getPageIndex(e) {
      // console.log(e,'index')
      // return;
      // this.pageIndex = e-1;
      var index = e;
      var keywords = this.keywords;
      this.get(index, keywords);
    },
    get(index, keywords) {
      var that = this;
      var pageIndex;
      if (index > 1) {
        pageIndex = index - 1;
      } else {
        pageIndex = 0;
      }

      //发送get请求
      this.$api
        .get("/downloadList?pageIndex=" + pageIndex)
        .then(
          function (res) {
            if (res.data.userInfo.userId == 0) {
              that.$router.push("/login");
            }else{
              that.userInfo = res.data.userInfo;
              that.tableData = res.data.page.list;
              that.count = res.data.page.count;
              that.pageIndex = res.data.page.index + 1;
              that.pagesize = res.data.page.size;
            }           
          },
          function () {
            that.$message.error("服务器异常，请稍后重试！");
          }
        );
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    logout() {
      var that = this;
      this.$api.post(`/mxdraw_logout`).then(
        function (res) {
         that.$router.push("/login");
          
        },
        function () {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
    },
    search() {
      var that = this;
      var keywords = that.keywords;
      var pageIndex = that.pageIndex;
      this.get(pageIndex, keywords);
      //alert(keywords)
    },
 
    download(uuid) {
      this.$api.post("/downloadfile", { uuid, uuid }).then(
        function (res) {
          if (res.data.code == "success") {
            window.location.href = res.data.url;
          } else if (res.data.code == "login") {
              that.$router.push("/login");
          } else {
            that.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        },
        function () {
          that.$message.error("服务器异常，请稍后重试！");
        }
      );
     
      // var that = this;
      // that.$router.push("/workinfo?uuid=" + uuid);
    },
  },
};
</script>

<style scoped>

  a {
    text-decoration:none;
    cursor:pointer !important;
  }
.hearder-tips {
  margin-left: 10px;
  float: right;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer
}
.el-breadcrumb {
  font-size: 17px;
  line-height: 60px;
}
.el-input-group {
    float: left;
    margin-bottom: 20px;
    width: 298px;
  float: left;
  margin-bottom: 20px;
}
.el-header,
.el-footer {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 60px;
  border-bottom: solid 1px #e6e6e6;
}

.el-aside {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 800px;
  height: 800px;
}

.el-main {
  background-color: #eef0f4;
  color: #333;
  text-align: center;
  /*line-height: 160px;*/
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.logo_img {
  width: 60px;
  height: 60px;
  line-height: 60px;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logout {
  cursor: pointer;
}
.el-pagination {
  /* margin-top: 20px;
  margin-bottom: 20px; */
  margin: 20px 0;
  float: right;
}
.hearder-tips {
  color: #333;
}
  .titile_logo{
      line-height: 60px;
      float: left;
      cursor: pointer;
  }

  .titile_logo a{
    color: #333;
    text-decoration:none;
    font-weight: 600;
    font-size: 1.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/downloadList.vue